import React from 'react';
import DateSelector from 'components/common/dateselector';
import PropTypes from 'prop-types';
const StatsMenu = (props) => {
    return (
        <div className="stats-menu" >
            <div className="pull-left display--flex--in-row">
                <div className="stats-menu__list flex--vertical--horizontal" >
                    <span className="stats-menu__list-item stats-menu__list-item_bold">
                        {props.leftItemBold}
                    </span>
                    {props.leftItems}
                </div>
            </div>

            <div className="pull-right display--flex--in-row">
                {props.withDateSelector &&
                    <div className="stats-menu__list flex--vertical--horizontal" >
                        <DateSelector />
                    </div>
                }
                {props.rightItems &&
                    <div className="stats-menu__list flex--vertical--horizontal">
                        {props.rightItems}
                    </div>
                }
            </div>
        </div>
    );
}
StatsMenu.propTypes = {
    withDateSelector: PropTypes.any,
    leftItemBold: PropTypes.any,
    leftItems: PropTypes.any,
    rightItems: PropTypes.any
}
export default StatsMenu;


// WEBPACK FOOTER //
// ./src/components/common/statsmenu.jsx